import { gql } from "@/gql/__generated__";
import { Get_Organization_Members_And_InvitationsQuery } from "@/gql/__generated__/graphql";
import { useMutation } from "@apollo/client";
import { GET_ORGANIZATION_MEMBERS_AND_INVITATIONS } from "../organization/getOrganizationMembersAndInvitations";

export const DELETE_ORGANIZATION_INVITATION = gql(`
  mutation DELETE_ORGANIZATION_INVITATION($invitationId: ID!) {
    organizationInvitationDelete(invitationId: $invitationId){
      ... on OrganizationInvitationDeleted {
          id
      }
      ... on OrganizationInvitationNotFound {
        id
      }
      ... on OrganizationNotFound {
        id
      }
    }
  }
`);

export const useDeleteOrganizationInvitation = () => {
  return useMutation(DELETE_ORGANIZATION_INVITATION, {
    update(cache, { data }) {
      if (
        !data ||
        data.organizationInvitationDelete?.__typename !==
          "OrganizationInvitationDeleted"
      )
        return;

      const deletedOrganizationId = data.organizationInvitationDelete.id;

      if (!deletedOrganizationId) return;

      cache.updateQuery(
        { query: GET_ORGANIZATION_MEMBERS_AND_INVITATIONS },
        (cacheData) => {
          if (
            !cacheData ||
            cacheData.organization.__typename !== "Organization"
          )
            return undefined;

          const updatedPendingInvitations =
            cacheData.organization.pendingInvitations.filter((invitation) => {
              return invitation.id !== deletedOrganizationId;
            });

          const updatedInvitationsList: Get_Organization_Members_And_InvitationsQuery =
            {
              __typename: "Query",
              organization: {
                ...cacheData.organization,
                pendingInvitations: updatedPendingInvitations
              }
            };
          return updatedInvitationsList;
        }
      );
    },
    refetchQueries: [GET_ORGANIZATION_MEMBERS_AND_INVITATIONS]
  });
};
